import React from 'react';
import {Navigate, useParams} from 'react-router-dom';

/**
 * /p/<codice>: il collegamento che sta nel messaggio di una giocata
 * prenotata.
 *
 * COSA FA: lascia il codice alla pagina dello sport e ci manda, perche' la
 * schedina vive la'. E' la pagina dello sport che lo legge, lo toglie e apre
 * la prenotazione -- la stessa strada del campo «Hai un codice?».
 * COSA NON FA: non chiede niente al servizio e non gioca. Un collegamento
 * ricevuto in chat non deve poter fare altro che compilare una schedina.
 */
export default function ApriPrenotazione() {
  const {codice} = useParams();
  const pulito = String(codice || '').trim().toUpperCase();
  if (pulito) {
    try {
      window.sessionStorage.setItem('prenotazioneDaAprire', pulito);
    } catch (e) {
      /* senza sessionStorage si arriva allo sport senza codice: il campo
         nella schedina vuota resta */
    }
  }
  return <Navigate to="/sport" replace />;
}
